import { render } from "./AuditoriumModule.vue?vue&type=template&id=b5fdae5e&scoped=true"
import script from "./AuditoriumModule.vue?vue&type=script&lang=js"
export * from "./AuditoriumModule.vue?vue&type=script&lang=js"

import "./AuditoriumModule.vue?vue&type=style&index=0&id=b5fdae5e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b5fdae5e"

export default script